import service from '@/services/item/ItemService'
import i18n from '@/i18n'

export const itemModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    typePriceFieldname: [
      'PRECOVAREJO',
      'PRECOATACADO',
      'PRECOESPECIAL',
      'PRECOESPECIAL2',
      'PRECOESPECIAL3',
    ],
    typeCurrencyFieldname: [
      'MOEDAVAREJO',
      'MOEDATACADO',
      'MOEDAESPECIAL',
      'MOEDAESPECIAL2',
      'MOEDAESPECIAL3',
    ],
    itemList: [],
    namesOfferList: [],
    loadingItems: false,
    pagination: {
      currentPage: 1,
      perPage: 1,
      lastPage: 1,
      total: 1,
    },
    error: '',
  },
  mutations: {
    CLEAR_ITENS(state) {
      state.itemList = []
    },
    SET_ITENS(state, payload) {
      if (payload && payload.current_page) {
        state.pagination.currentPage = payload.current_page
        state.pagination.lastPage = payload.last_page
        state.pagination.total = payload.total
      }
      state.pagination.perPage = parseInt(payload.per_page)
      state.itemList = payload.data ?? []
    },
    /* Atualiza a lista de nomes de oferta */
    SET_NAME_OFFER_LIST(state, payload) {
      if (payload && payload.nomeslistaoferta) {
        state.namesOfferList = payload.nomeslistaoferta
      }
    },
    ADD_ITENS(state, payload) {
      if (payload.current_page) {
        state.pagination.currentPage = payload.current_page
        state.pagination.lastPage = payload.last_page
        state.pagination.total = payload.total
      }
      state.pagination.perPage = parseInt(payload.per_page)
      let dados = payload.data ?? payload
      state.itemList = state.itemList.concat(dados)
    },
    SET_LOADING_ITENS(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getItens({ commit }, { query, type = 'item' }) {
      try {
        commit('SET_LOADING_ITENS')
        let response = await service.getItens(query)

        /* Atualiza a lista de nomes de oferta */
        commit('SET_NAME_OFFER_LIST', response)
        if (type == 'item')
          commit('SET_ITENS', response)
        else
          commit('ADD_ITENS', response)
      } finally {
        commit('SET_LOADING_ITENS')
      }
    },
    async getItem(context, payload) {
      let data = await service.getItem(payload)

      return data
    },
    async updateItemList({ dispatch, state }, payload) {
      let preco = ''
      state.typePriceFieldname.forEach((e, index) => {
        if (e === payload.tipoPreco) {
          preco = index
        }
      })
      payload.tipoPreco = preco
      const query = {
        query: payload,
      }
      await dispatch('getItens', query)
    },

    clearItemList({ commit }) {
      commit('CLEAR_ITENS')
    },
  },
  getters: {
    getComboBoxList: (state) => {
      if (state.itemList.total == 0) return
      let comboBox = state.itemList.map((item) => {
        const codBarras = item.CODIGOBARRAS ?? i18n.t('labels.naoPossui')
        return {
          ...item,
          DESCRICAO:
            item.CODIGO +
            ' - ' +
            item.DESCRICAO +
            ' | Cód. Barras: ' +
            codBarras,
          DESCRICAO1: item.DESCRICAO,
        }
      })
      return comboBox
    },

    getItemList: (state) => {
      return state.itemList
    },
    getPagination: (state) => {
      return state.pagination
    },
  },
}
